import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag} from "../../utils";
import Wysiwyg from '../wysiwyg';
import Html from '../html';
import OneColumnLayout from '../one-column-layout';
import TwoColumnLayout from '../two-column-layout';
import ThreeColumnLayout from '../three-column-layout';
import FourColumnLayout from '../four-column-layout';
import {WINDOW} from '../../constants/environment'
import './styles.css';

/**
 *  AccordionItem
 */
class AccordionItem extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    pcText: PropTypes.string,
    mbText: PropTypes.string,
    components: PropTypes.array,
    open: PropTypes.bool,
    color: PropTypes.string
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    pcText: null,
    mbText: null,
    components: null,
    open: null,
    color: null
  };

  constructor(props) {
    super();
    this.props = props;

    this.state = {
      open: this.props.open != null && this.props.open === true ? true : false,
      contentHeight: this.props.open != null && this.props.open === true ? 'auto' : 0,
    };

    this.innerRef = React.createRef();
    this.onResize = this.onResize.bind(this);
    this.intervalId = null;

  }

  componentDidMount() {
    this.setState({
      contentHeight: this.state.open ? this.innerRef.current.clientHeight : 0
    });
    WINDOW.addEventListener('resize', this.onResize);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(()=> {
      this.onResize();
    }, 500)

  };

  componentWillUnmount() {
    WINDOW.removeEventListener('resize', this.onResize);
    if (this.intervalId) clearInterval(this.intervalId);
  };

  onResize() {
    this.setState({
      contentHeight: this.state.open ? this.innerRef.current.clientHeight : 0
    });
  }

  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      pcText,
      mbText,
      components,
      open,
      color
    } = this.props;

    let itemPcText, itemMbText;
    itemPcText = pcText != null && pcText !== '' ? pcText : '';
    itemMbText = mbText != null && mbText !== '' ? mbText : (pcText != null && pcText !== '' ? pcText : '');

    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className='AccordionItem'>
          <div className={'AccordionItem__container AccordionItem__container--' + color + ' AccordionItem__container--' + (this.state.open ? 'open' : 'close')}>
            <div className="AccordionItem__container__title" onClick={this.onClick}>
              {(itemPcText && itemPcText !== '') ? <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(itemPcText)}} className="AccordionItem__container__title__text--pc"/>: null}
              {(itemMbText && itemMbText !== '') ? <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(itemMbText)}} className="AccordionItem__container__title__text--mb"/>: null}
              <div className="AccordionItem__container__title__icon">
                <span className="AccordionItem__container__title__icon__v" />
                <span className="AccordionItem__container__title__icon__h" />
              </div>
            </div>
            <div className={"AccordionItem__container__content"} style={{height: this.state.contentHeight}}>
              <div className={"AccordionItem__container__inner"} ref={this.innerRef}>
                {components.map((component, index) => {
                  if(component.name === 'Wysiwyg'){
                    return(
                      <Wysiwyg {...component.props} key={index} />
                    )
                  }
                  else if(component.name === 'Html'){
                    return(
                      <Html {...component.props} key={index} />
                    )
                  }
                  else if(component.name === 'OneColumnLayout'){
                    return(
                      <OneColumnLayout {...component.props} key={index} />
                    )
                  }
                  else if(component.name === 'TwoColumnLayout'){
                    return(
                      <TwoColumnLayout {...component.props} key={index} />
                    )
                  }
                  else if(component.name === 'ThreeColumnLayout'){
                    return(
                      <ThreeColumnLayout {...component.props} key={index} />
                    )
                  }
                  else if(component.name === 'FourColumnLayout'){
                    return(
                      <FourColumnLayout {...component.props} key={index} />
                    )
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }

  onClick = (e) => {
    let isOpen = !this.state.open;
    this.setState({
      open: isOpen,
    });
    setTimeout(()=> {
      this.setState({
        contentHeight: this.state.open ? this.innerRef.current.clientHeight : 0
      });
    }, 100)
  };

}

export default AccordionItem;



// WEBPACK FOOTER //
// ./src/containers/accordion-item/index.jsx